import { mark, measure } from 'atlas-core/src/lib/performance';
import {
  addErrorHandler,
  getAppStatus,
  LOAD_ERROR,
  registerApplication,
  start,
} from 'single-spa';
import {
  constructApplications,
  constructLayoutEngine,
  constructRoutes,
} from 'single-spa-layout';

import { getReplaceStateUrl } from './helpers/getReplaceStateUrl';
import { redirectPaths } from './helpers/redirects';

export function startComposer(): void {
  mark('dcmfe:composer:start');

  const replaceStateUrl = getReplaceStateUrl({
    href: window.location.href,
    pathname: window.location.pathname,
  });

  if (replaceStateUrl) {
    // use window.history.replaceState so as to not cause a page reload
    window.history.replaceState({}, '', replaceStateUrl);
  }

  const clientType = window?.dcmfe?.env?.clientType || 'browser';
  const cspUniqueNonce = window?.dcmfe?.env?.nonce || '';
  const enableHomeHubUpgrades =
    window?.dcmfe?.env?.enableHomeHubUpgrades || false;
  const geoCountry = window?.dcmfe?.env?.geoCountry || '';
  const inIframe = window?.dcmfe?.env?.inIframe || false;

  const props = {
    _preload: null,
    _ssrOwner: null,
    clientType,
    cspUniqueNonce,
    disallowedRoutes: [/^\/$/i],
    enableHomeHubUpgrades,
    geoCountry,
    inIframe,
  };
  if (window?.dcmfe?.ssrProps) {
    Object.assign(props, window?.dcmfe?.ssrProps);
  }

  const routes = constructRoutes(
    document.querySelector('#single-spa-layout') as HTMLTemplateElement,
    {
      errors: {
        defaultError:
          '<div class="mfe-app-error"><p>An error occurred. Please try reloading the page. If this issue persists, please check our <a href="https://status.datacamp.com">status page</a> or contact <a href="https://support.datacamp.com">support</a>.</p></div>',
      },
      loaders: {},
      props,
    },
  );

  const applications = constructApplications({
    loadApp({ name }) {
      return System.import(name);
    },
    routes,
  });

  const layoutEngine = constructLayoutEngine({ applications, routes });

  applications.forEach((application) => registerApplication(application));

  layoutEngine.activate();

  addErrorHandler((err) => {
    if (getAppStatus(err.appOrParcelName) === LOAD_ERROR) {
      System.delete(System.resolve(err.appOrParcelName));
    }
  });

  start();

  window.addEventListener(
    'single-spa:before-routing-event',
    redirectPaths,
    false,
  );

  mark('dcmfe:composer:end');
  measure('dcmfe:composer', 'dcmfe:composer:start', 'dcmfe:composer:end');
}
